document.addEventListener('DOMContentLoaded', () => {
  const tabNavs = document.querySelectorAll('.tabNav');
  const tabs = document.querySelectorAll('.tab');

  tabNavs.forEach((nav) => {
    nav.addEventListener('click', () => {
      const targetId = nav.dataset.target;
      const target = document.querySelector(targetId);

      if (!target) return;

      tabNavs.forEach((item) => {
        item.classList.remove('active');
      });

      nav.classList.add('active');

      tabs.forEach((tab) => {
        if (tab === target) {
          tab.classList.add('active');
        } else {
          tab.classList.remove('active');
        }
      });
    });
  });
});
